import React from 'react';
import { Autocomplete, TextField, Chip, Avatar } from '@mui/material';
import {TEXT_FIELD_STYLE} from "../../constants/Styles";
import { StyledTextField } from './StyledTextField';

const StyledAvatarChipsTextField = ({
  options = [],
  onChange,
  value=[],
  autocompleteProps,
  ...props // <-- this contains label, error, helperText, etc.
}) => {
  return (
    <Autocomplete
      multiple
      disablePortal
      options={options}
      value={value}
      getOptionLabel={(option) => option.name}
      fullWidth
      onChange={onChange}
      renderInput={(params) => (
        <StyledTextField {...props} {...params} />
      )}
      {...autocompleteProps}
    />
  )
}

export default StyledAvatarChipsTextField;